import axios from '@/libs/api.request'
var qs = require('qs');

export const login = ({ userName, password }) => {
    let data = {
        username: userName,
        password: password

    }
    data = qs.stringify(data)
    return axios.request({
        url: 'login-exit/login',
        data,
        method: 'post'
    })
}

export const getUserInfo = (token) => {
    // var data = {
    //     'access': ['agentList', 'agentManagement', 'schoolManagement', 'schoolList', 'teacherList', 'studentList', 'classList', 'chapterPermission',
    //         'appContent', 'courseCategory', 'studentCourseCatalogue', 'courseMassage', 'teacherCourseCatalogue', 'bannerList',
    //         'videoManagement', 'everydayList', 'askMeAbout', 'operationManagement', 'schoolOrder', 'orderList', 'memberPricing',
    //         'chargesSatistics', 'systemManagement', 'adminList', 'roleList', 'editionManage',
    //     ],
    // }
    // return data;
    return axios.request({
        url: '/role-management/get-user-info',
        method: 'post'
    })
}

export const logout = (token) => {
    return axios.request({
        url: 'logout',
        method: 'post'
    })
}